import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import UACLogoSmall from "assets/UAC-Logo-Small.png";
import SubjectCompassLogo from "assets/Subject Compass Logo.svg";
import IconMobileMenu from "assets/Icon-Mobile-Menu.svg";
import "styles/MobileNavbar.scss";

export default class MobileNavbar extends Component {
  state = { showMenu: false };

  openMenu = () =>
    this.setState({ showMenu: true }, () => {
      document.addEventListener("click", this.closeMenu);
    });

  closeMenu = (event) => {
    this.setState({ showMenu: false }, () => {
      document.removeEventListener("click", this.closeMenu);
    });
  };

  render() {
    return (
      <div className="tablet-and-mobile ">
        <div className="top-navbar">
          <div>
            <NavLink to="/">
              <img
                className="mobile-uac-logo"
                src={UACLogoSmall}
                alt="Uac Logo"
              />
            </NavLink>

            <NavLink to="/">
              <img
                className="mobile-subject-compass-logo"
                src={SubjectCompassLogo}
                alt="Subject Compass Logo"
              />
            </NavLink>
          </div>
          <img
            onClick={this.openMenu}
            className="mobile-menu-icon"
            src={IconMobileMenu}
            alt="Subject Compass Logo"
          />
        </div>
        {this.state.showMenu && (
          <div className="mobile-menu">
            <a
              className="footer-link"
              target="_blank"
              rel="noopener noreferrer"
              href="https://uac.edu.au"
            >
              Return to UAC website
            </a>
          </div>
        )}
      </div>
    );
  }
}
